import { render, staticRenderFns } from "./ModalExibeFotoProduto.vue?vue&type=template&id=13344a8c"
import script from "./ModalExibeFotoProduto.vue?vue&type=script&lang=js"
export * from "./ModalExibeFotoProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports